import React from 'react';

const fields = [
  ['cep', 'CEP'],
  ['logradouro', 'Logradouro'],
  ['numero', 'Número'],
  ['complemento', 'Complemento'],
  ['bairro', 'Bairro'],
  ['cidade', 'Cidade'],
  ['estado', 'Estado'],
];

export default function OrganizationAddressFields({
  address,
  changeField,
  lookupCep,
  isFetching,
  error,
}) {
  return (
    <>
      <h3 className="portal-form-section-title">Endereço</h3>
      <div className="portal-admin-grid">
        {fields.map(([name, label]) => (
          <label className="form-label" key={name}>
            <span>
              {label} <small className="text-muted">(opcional)</small>
            </span>
            <input
              className="form-control"
              name={`endereco[${name}]`}
              value={address[name] || ''}
              onChange={(event) => changeField(name, event.target.value)}
              onBlur={name === 'cep' ? lookupCep : undefined}
              inputMode={name === 'cep' ? 'numeric' : undefined}
              autoComplete={name === 'cep' ? 'postal-code' : undefined}
              maxLength={name === 'cep' ? 9 : 255}
              placeholder={name === 'cep' ? '00000-000' : undefined}
              aria-describedby={name === 'cep' ? 'organization-cep-status' : undefined}
              aria-busy={name === 'cep' ? isFetching : undefined}
            />
            {name === 'cep' && (
              <small
                id="organization-cep-status"
                className={error ? 'form-text text-danger' : 'form-text'}
                role="status"
                aria-live="polite"
              >
                {isFetching
                  ? 'Consultando CEP…'
                  : error ||
                    'Ao sair do campo, o CEP completo preenche o endereço automaticamente.'}
              </small>
            )}
          </label>
        ))}
      </div>
    </>
  );
}
